import { Link } from "react-router-dom";

export default function Logo({ variant = "dark", className = "" }) {
  const isDark = variant === "dark";
  return (
    <Link
      to="/"
      data-testid="site-logo"
      className={`inline-flex items-center gap-2 group ${className}`}
      aria-label="Áxis Saúde Digital — página inicial"
    >
      <span className="relative inline-flex items-center justify-center w-9 h-9">
        <span
          aria-hidden
          className="absolute inset-0 border-2 border-[#1E3A8A] rotate-45 transition-transform duration-300 group-hover:rotate-[60deg]"
        />
        <span
          aria-hidden
          className="relative w-2 h-2 bg-[#1E3A8A] rounded-full"
        />
      </span>
      <span
        className={`font-display font-semibold text-lg tracking-tight ${
          isDark ? "text-[#111827]" : "text-white"
        }`}
      >
        Áxis<span className="text-[#1E3A8A]">.</span>
        <span className="font-normal ml-1 opacity-80">Saúde Digital</span>
      </span>
    </Link>
  );
}
